"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var initialState = {
  currentUser: {
    isSignedIn: false,
    isLoading: false,
    attributes: {}
  }
};
exports.default = initialState;